import { useRef, useEffect, useState } from 'react'
import db from "../../firebase-config"
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme, Button } from "@mui/material";
import { tokens } from "../../theme";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Watch from "../../assets/img/watch.png";
import Temperature from "../../assets/img/temperature.png";
import Disconnect from '../../assets/img/disconnect.png';
import Pngegg from '../../assets/img/pngegg.png';
import Shapes from '../../assets/img/shapes.png';


const Item = styled(Paper)(({ theme }) => ({
    //backgroundColor: 'transparent',
    padding: theme.spacing(0.8),
    textAlign: 'center',
    //border: '0.8px dashed #c2c2c2',
    borderRadius: "0px 0px 20px 20px",
    //height: { xs: "87%", md: "100%" },

}));

const ItemTotal = styled(Paper)(({ theme }) => ({
    backgroundColor: 'transparent',
    padding: theme.spacing(4),
    textAlign: 'center',
    //border: '0.5px dashed #4A4A49',
    borderRadius: 8,
    width: '100%',

}));

const ItemCondition = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(0.8),
    textAlign: 'center',
    backgroundColor: '#6e6d6d',
    borderRadius: "10px 10px 0px 0px",
    width: '100%'

}));


const ItemFryer = styled(Paper)(({ theme }) => ({
    //backgroundColor: 'transparent',
    padding: theme.spacing(0.8),
    textAlign: 'center',
    backgroundColor: '#404040',
    borderRadius: "0px 0px 10px 10px",
    width: '100%'

}));
function PopupQualityMonitoring(props) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [quality_monitoring, setQuality_monitoring] = useState([]);
    const [quality_monitoring_taglist, setQuality_monitoring_taglist] = useState([]);

    useEffect(() => {
        const docIdLine7 = 'Thailand411700000000000000Line7Defect_AI_Inspection';
        const docRefLine7 = db.collection('prod_mes_ignition_defect_dashboard_ai_inspection').doc(docIdLine7);

        const unsubscribeLine7 = docRefLine7.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setQuality_monitoring([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
                //setLoading(true)
                sessionStorage.setItem("QualityLine7", JSON.stringify([{ ...docSnapshot.data(), id: docSnapshot.id }][0]));
            } else {
                console.log('No such document!');
                setQuality_monitoring([]);
            }
        });

        const subscriberQuality = db
            .collection("prod_mes_ignition_defect_dashboard_tag_list")
            .onSnapshot((querySnapshot) => {
                const qualityData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                setQuality_monitoring_taglist(qualityData);
                sessionStorage.setItem("QualityTaglistLine7", JSON.stringify(qualityData));
            });
        return () => {
            unsubscribeLine7();
            subscriberQuality();
        }
    }, []);


    const fryerTemp1 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5108.Line7.SP_FryerTemp"));

    const fryerTime1 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5108.Line7.SP_Time"));

    const fryerTempColor1 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5108.Line7.FryerTemperature"));

    const fryerTemp2 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5107.Line7.SP_FryerTemp"));

    const fryerTime2 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5107.Line7.SP_Time"));

    const fryerTempColor2 = quality_monitoring_taglist.find((a) => a.TAG_NAME.includes("Further.4117.00000000000000.Thailand.Fryer.EFRB5107.Line7.FryerTemperature"));

    const fryerColor1 = () => {
        let color;
        try {
            if (fryerTempColor1?.VALUE == undefined ? 0 : fryerTempColor1?.VALUE == fryerTemp1?.VALUE) {
                color = "#2e9281"
            } else if (fryerTempColor1?.VALUE == undefined ? 0 : fryerTempColor1?.VALUE > fryerTemp1?.VALUE) {
                color = "#bd290b"
            } else if ((fryerTempColor1?.VALUE == undefined ? 0 : fryerTempColor1?.VALUE < fryerTemp1?.VALUE)) {
                color = "#0556e3"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const fryerColor2 = () => {
        let color;
        try {
            if (fryerTempColor2?.VALUE == undefined ? 0 : fryerTempColor2?.VALUE == fryerTemp2?.VALUE) {
                color = "#2e9281"
            } else if (fryerTempColor2?.VALUE == undefined ? 0 : fryerTempColor2?.VALUE > fryerTemp2?.VALUE) {
                color = "#bd290b"
            } else if ((fryerTempColor2?.VALUE == undefined ? 0 : fryerTempColor2?.VALUE < fryerTemp2?.VALUE)) {
                color = "#0556e3"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    return (
        <div>
            <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} style={{ paddingTop: 3, paddingLeft: 11, paddingRight: 3 }}>
                <Grid item xs={8}>
                    <Item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: 'transparent' }}>
                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 20 }}>
                            <Typography style={{ color: colors.neutral['white'], fontSize: 72, fontWeight: 'bold', lineHeight: "20px", paddingTop: 10 }} >
                                Quality Monitoring
                            </Typography>
                        </Grid>
                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 30 }}>
                            <ItemTotal >
                                <Grid item xs={12} textAlign="center" >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '835px' }} textAlign="center" >
                                    </Box>
                                    <img src={Disconnect} height="160px" />
                                    <Typography sx={{ color: "#EF193B", fontWeight: "bold", fontSize: 64 }}>
                                        Disconnect
                                    </Typography>
                                    <Typography sx={{ color: "#EF193B", fontWeight: "bold", fontSize: 64 }}>
                                        Line 7
                                    </Typography>
                                </Grid>
                            </ItemTotal>
                        </Grid>
                    </Item>
                </Grid>
                <Grid item xs={4}>
                            <Grid container spacing={0}>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 20 }} >
                                    <ItemCondition>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 10 }} >
                                            <Typography style={{ color: colors.neutral['white'], fontSize: 48, fontWeight: 'bold', lineHeight: "30px", paddingTop: 0 }} >
                                                M/C Condition
                                            </Typography>
                                        </Grid>
                                    </ItemCondition>
                                    <ItemFryer>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 5 }} >
                                            <Grid container spacing={0.8}>
                                                <Grid item xs={5}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 56, fontWeight: 'bold', lineHeight: "40px", paddingTop: 0 }} >
                                                            Fryer
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 56, fontWeight: 'bold', lineHeight: "40px", paddingTop: 40 }} >
                                                            1
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <table style={{ width: '70%' }}>
                                                        <tbody>
                                                            <tr >
                                                                <td style={{ width: '30%', lineHeight: "6vh" }} align="right">
                                                                    <img src={Temperature} height="50vh" />
                                                                </td>
                                                                <td style={{ width: '20%', color: fryerColor1(), fontSize: 56, fontWeight: 'bold', lineHeight: "4vh" }} align="right">
                                                                    {fryerTemp1?.VALUE == undefined ? '-' : fryerTemp1?.VALUE}
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold', lineHeight: "4vh", paddingTop: 4 }} align="left">
                                                                    ํC
                                                                </td>
                                                            </tr>
                                                            <tr >
                                                                <td style={{ width: '30%', lineHeight: "4vh" }} align="right">
                                                                    <img src={Watch} height="50vh" />
                                                                </td>
                                                                <td style={{ width: '20%', color: '#2e9281', fontSize: 56, fontWeight: 'bold', lineHeight: "4vh" }} align="right">
                                                                    {fryerTime1?.VALUE == undefined ? '-' : Math.round(fryerTime1?.VALUE / 60)}
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold', lineHeight: "4vh", paddingTop: 4 }} align="left">
                                                                    min
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={11} sx={{ borderBottom: "0.5px dashed #c2c2c2", position: "relative", marginLeft: { xs: "2vh", md: "3vh" } }} >

                                        </Grid>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 10 }} >
                                            <Grid container spacing={0.8}>
                                                <Grid item xs={5}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 56, fontWeight: 'bold', lineHeight: "40px", paddingTop: 0 }} >
                                                            Fryer
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 56, fontWeight: 'bold', lineHeight: "40px", paddingTop: 40 }} >
                                                            2
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <table style={{ width: '70%' }}>
                                                        <tbody>
                                                            <tr >
                                                                <td style={{ width: '30%', lineHeight: "4vh" }} align="right">
                                                                    <img src={Temperature} height="50vh" />
                                                                </td>
                                                                <td style={{ width: '20%', color: '#2e9281', fontSize: 56, fontWeight: 'bold', lineHeight: "4vh" }} align="right">
                                                                    {fryerTemp2?.VALUE == undefined ? '-' : fryerTemp2?.VALUE}
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold', lineHeight: "4vh", paddingTop: 4 }} align="left">
                                                                    ํC
                                                                </td>
                                                            </tr>
                                                            <tr >
                                                                <td style={{ width: '30%', lineHeight: "4vh" }} align="right">
                                                                    <img src={Watch} height="50vh" />
                                                                </td>
                                                                <td style={{ width: '20%', color: fryerColor2(), fontSize: 56, fontWeight: 'bold', lineHeight: "4vh" }} align="right">
                                                                    {fryerTime2?.VALUE == undefined ? '-' : Math.round(fryerTime2?.VALUE / 60)}
                                                                </td>
                                                                <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold', lineHeight: "4vh", paddingTop: 4 }} align="left">
                                                                    min
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </ItemFryer>
                                </Grid>

                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 5 }} >
                                    <ItemCondition>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 5 }} >
                                            <Typography style={{ color: colors.neutral['white'], fontSize: 48, fontWeight: 'bold', lineHeight: "30px", paddingTop: 0 }} >
                                                Avg Core Temp
                                            </Typography>
                                        </Grid>
                                    </ItemCondition>
                                    <ItemFryer>
                                        <Grid item xs={12} textAlign="center" style={{ paddingTop: 0 }} >
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: "relative", marginTop: { xs: "4vh", md: "2vh" } }} textAlign="center" >
                                                <Typography style={{ color: '#2e9281', fontSize: 64, lineHeight: "40px", paddingTop: 0 }} >
                                                    {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.AVG_CORE_TEMP}&nbsp;
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['grey'], fontSize: 40, fontWeight: 'bold', lineHeight: "40px", paddingTop: 4 }} >
                                                    ํC&nbsp;&nbsp;
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 64, lineHeight: "40px", paddingTop: 0 }} >
                                                    {quality_monitoring?.WARNING == undefined ? '-' : quality_monitoring?.LATEST_AVG_CORE_TEMP}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </ItemFryer>
                                </Grid>
                            </Grid>
                        </Grid>
            </Grid>
        </div>
    );
}

PopupQualityMonitoring.propTypes = {}

export default PopupQualityMonitoring